import { render, staticRenderFns } from "./cp_news_items.vue?vue&type=template&id=3b2b274e&scoped=true"
import script from "./cp_news_items.vue?vue&type=script&lang=js"
export * from "./cp_news_items.vue?vue&type=script&lang=js"
import style0 from "./cp_news_items.vue?vue&type=style&index=0&id=3b2b274e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2b274e",
  null
  
)

export default component.exports